import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { textStyles } from "../../../../theme/foundations/generated";
import { getBorderColor, getIconColor, getTextColor, } from "../FileUploader.helpers";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "fileUploader",
    "dropzone",
    "wrapper",
    "dropzoneFiles",
    "files",
    "file",
    "rightIcon",
    "helpText",
]);
const baseStyle = definePartsStyle(({ isDisabled, isInvalid, isMoreThanOneFile, addBorder }) => ({
    fileUploader: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "400px",
        height: "100%",
    },
    dropzone: Object.assign(Object.assign({ height: "120px", display: "flex", alignItems: "center", marginBottom: ".5rem", padding: "1rem .75rem 1rem 1rem", backgroundColor: "semantic.background.info", border: `${addBorder ? 1 : 2}px solid `, borderColor: getBorderColor(isInvalid, addBorder) }, textStyles.body.medium), { cursor: isDisabled ? "not-allowed" : "auto", "&.dropzone.active": {
            border: isInvalid ? "2px solid" : "2px dashed",
            borderColor: isInvalid
                ? "semantic.border.error"
                : "semantic.outline.focus",
        }, _focusVisible: {
            outlineColor: "semantic.outline.focus ",
            outlineWidth: "3px",
            outlineStyle: "solid",
        } }),
    wrapper: {
        flex: 1,
        display: "flex",
        alignItems: "center",
        height: "100%",
    },
    dropzoneFiles: {
        flex: 1,
        padding: "0rem .5rem 0rem 1.5rem",
        position: "relative",
        height: "100%",
        width: "14.25rem",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: isMoreThanOneFile ? "start" : "center",
        color: getTextColor({ isDisabled }),
    },
    files: {
        display: "flex",
        rowGap: ".5rem",
        flexDirection: "column",
        alignItems: "start",
    },
    file: {
        minHeight: "fit-content",
    },
    rightIcon: {
        display: "flex",
        alignItems: "center",
        color: getIconColor({ isDisabled, isInvalid }),
    },
    helpText: Object.assign(Object.assign({}, textStyles.body.smallDemibold), { color: isInvalid ? "semantic.text.error" : "semantic.text.tertiary" }),
}));
const sizes = {
    desktop: definePartsStyle({}),
    mobile: definePartsStyle(({ isDisabled, isInvalid }) => ({
        fileUploader: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            width: "320px",
            height: "100%",
        },
        dropzone: {
            height: "auto",
            minHeight: "104px",
            maxHeight: "184px",
            overflow: "hidden",
            display: "flex",
            alignItems: "start",
            flexDirection: "column",
            cursor: isDisabled ? "not-allowed" : "auto",
            "&.dropzone.active": {
                border: isInvalid ? "2px solid" : "2px dashed",
                borderColor: isInvalid
                    ? "semantic.border.error"
                    : "semantic.outline.focus",
            },
        },
        wrapper: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "start",
            width: "100%",
            justifyContent: "space-between",
        },
        dropzoneFiles: {
            display: "flex",
            padding: "0",
            marginTop: "1.5rem",
            width: "16rem",
            justifyContent: "start",
        },
        files: {
            display: "flex",
            overflowY: "auto",
            flex: 1,
        },
    })),
};
const FileUploaderTheme = defineMultiStyleConfig({
    baseStyle,
    sizes,
    defaultProps: {
        size: "mobile",
    },
});
export default FileUploaderTheme;
//# sourceMappingURL=FileUploader.default.js.map